'use strict';

/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };
}();

(function ($) {

  "use strict";

  var myApp = {};

  myApp.init = function () {

    var ticking = false;
    var last_known_scroll_position;
    var headerFixed = $('.navbar-fixed-top');
    var menuToggle = $('.navbar-toggle');
    var menuCloseBtn = $('.side-navbar-close-btn');
    var mainNav = $('#main-nav');
    var sideMenuClosed = true;
    var $video = $('.masthead-video-bg');
    ruralApp.options.isOnePage = false;

    // Video Play
    if ($video.get(0) !== undefined) {

      // Show loading animation.
      var playPromise = $video.get(0).play();

      if (playPromise !== undefined) {
        playPromise.then(function () {
          // $video.get(0).play();
        }).catch(function (error) {
          console.log(error);
        });
      }
    }

    ruralApp.Flexslider.initFlex('.flexslider', {
      animation: 'fade'
    });

    ruralApp.MagnificPopup.initMagnific('.gallery', {
      delegate: 'a',
      type: 'image',
      gallery: {
        enabled: true
      }
    });

    ruralApp.MagnificPopup.initMagnific('.image-popup', {
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: {
        verticalFit: false
      }
    });

    $('body').scrollspy({
      target: '#main-nav',
      offset: mainNav.outerHeight(true)
    });

    if (typeof $.magnificPopup !== 'undefined') {

      $('.gallery').each(function () {
        $(this).magnificPopup({
          delegate: 'a',
          type: 'image',
          gallery: {
            enabled: true
          }
        });
      });
    }

    if (typeof $.fn.slick !== 'undefined') {
      $('#lotes-slick').on('init', function (event, slick) {
        $('.slick-current').prev().addClass('prev');
        $('.slick-current').next().addClass('next');
      }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.slick-current').removeClass('prev next');
      }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $('.slick-current').prev().addClass('prev');
        $('.slick-current').next().addClass('next');
        $('.slick-current').removeClass('prev next');
      });

      $('#lotes-slick').slick({
        centerMode: true,
        centerPadding: '150px',
        dots: true,
        arrows: false,
        infinite: true,
        initialSlide: 1,
        autoplay: true,
        slidesToShow: 1,
        responsive: [{
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '120px',
            slidesToShow: 1
          }
        }, {
          breakpoint: 650,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '80px',
            slidesToShow: 1
          }
        }, {
          breakpoint: 550,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: 1
          }
        }, {
          breakpoint: 481,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '20px',
            slidesToShow: 1
          }
        }]

      });
    }

    if (typeof $.fn.slick !== 'undefined') {
      $('.empresa-team-list-slick').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        centerPadding: '100px',
        infinite: true,
        autoplay: true,
        dots: false,
        responsive: [{
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            dots: false
          }
        }, {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            dots: false
          }
        }, {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            dots: false
          }
        }, {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            dots: false
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        }]
      });
    }

    menuToggle.click(function (ev) {
      openMenu();
    });

    function openMenu() {
      if (sideMenuClosed) {
        // open menu
        mainNav[0].style.transform = 'translateX(0)';
        sideMenuClosed = false;
        $(this).addClass('opened');
      } else {
        closeMenu();
      }
    }

    $(document).mouseup(function (e) {
      var container = $(".side-navbar");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        closeMenu();
      }
    });

    menuCloseBtn.click(function (ev) {
      closeMenu();
    });

    function closeMenu() {
      if (!sideMenuClosed) {
        mainNav[0].style.transform = 'translateX(120%)';
        sideMenuClosed = true;
        menuToggle.removeClass('opened');
      }
    }

    if (window.innerWidth > 991) {
      // window.addEventListener('scroll', function(e) {
      //   last_known_scroll_position = window.scrollY;
      //   if (!ticking) {
      //     window.requestAnimationFrame(function() {
      //       checkScrollPos(last_known_scroll_position);
      //       ticking = false;
      //     });
      //   }
      //   ticking = true;

      // });
    } else {
      $(document).mouseup(function (e) {
        if (!mainNav.is(e.target) && mainNav.has(e.target).length === 0 && !menuToggle.is(e.target) && menuToggle.has(e.target).length === 0) {
          closeMenu();
        }
      });
    }

    function checkScrollPos(scroll_pos) {
      if (scroll_pos > 100) {
        $('.navbar-collapse-wrapper').addClass('fixed-top');
        $('body').addClass('navbar-is-fixed');
      } else {
        $('.navbar-collapse-wrapper').removeClass('fixed-top');
        $('body').removeClass('navbar-is-fixed');
      }
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    myApp.init();
  }, false);
})(jQuery);